<template>
  <el-dialog
      :title="fullNameTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <el-form
        label-width="120px"
        :model="attendanceEmployee.attendanceLeaveEmployee"
        label-position="top"
        ref="attendanceEmployee"
    >
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="24">
          <div class="shift-card">
            <div class="shift-header">
              <strong>Chấm công về</strong>
            </div>

            <div class="shift-row">
              <!-- Ảnh về + upload -->
              <div class="shift-col shift-media">
                <div class="shift-media-title">Ảnh về</div>
                <image-uploader
                    v-model="attendanceEmployee.attendanceLeaveEmployee.leavePictureFile"
                    :preview="attendanceEmployee.attendanceLeaveEmployee.leavePicture"
                    placeholder="Tải ảnh về"
                    :updateAttendance="true"
                    @change="handleImageChange"
                />
                <div class="shift-time">
                  Giờ về: <span>{{ attendanceEmployee.attendanceLeaveEmployee.leaveTime | formatTime }}</span>
                </div>
              </div>

              <!-- Ghi chú + thông tin -->
              <div class="shift-col shift-note">
                <div class="shift-media-title">Ghi chú</div>
                <el-input
                    type="textarea"
                    :rows="4"
                    v-model="attendanceEmployee.attendanceLeaveEmployee.leaveContent"
                    placeholder="Nhập nội dung / ghi chú cho chấm công về"
                />

                <!-- Thông tin người thực hiện -->
                <div class="shift-status" style="margin-top: 20px;" v-if="attendanceEmployee.attendanceLeaveEmployee.createdBy">
                  <div v-if="attendanceEmployee.attendanceLeaveEmployee.createdDate !== attendanceEmployee.attendanceLeaveEmployee.lastModifieDate">
                    <strong>Chấm công:</strong> {{ attendanceEmployee.attendanceLeaveEmployee.lastModifieBy }}
                    <div style="margin-top: 6px;"  v-if="attendanceEmployee.attendanceLeaveEmployee.lastModifieDate !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceEmployee.attendanceLeaveEmployee.lastModifieDate | formatDateTime }}
                    </div>
                  </div>
                  <div v-else>
                    <strong>Chấm công:</strong> {{ attendanceEmployee.attendanceLeaveEmployee.createdBy }}
                    <div style="margin-top: 6px;" v-if="attendanceEmployee.attendanceLeaveEmployee.createdDate !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceEmployee.attendanceLeaveEmployee.createdDate | formatDateTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('attendanceEmployee')"
      >
        <i class="el-icon-circle-close" /> Đóng
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          @click="submitForm('attendanceEmployee')"
      >
        <i class="el-icon-circle-check" /> Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ImageUploader from "@/utils/view/ImageUploader.vue"; // Giả sử import giống phần đến
import AttendanceEmployeeService from "@/services/EmployeeService/AttendanceEmployeeService";

export default {
  name: "AttendanceLeaveEmployeeDialog",
  components: {
    ImageUploader
  },
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      attendanceEmployee: {
        attendanceLeaveEmployee: {
          leavePicture: null,          // URL ảnh hiện tại
          leavePictureFile: null,      // File mới upload
          leaveTime: null,
          leaveContent: "",
          createdBy: "",
          createdDate: "",
          lastModifieBy: "",
          lastModifieDate: "",
          id: null
        }
      },
      fullNameTitle: "",
      loadingButton: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog-close", false);
      this.resetForm();
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    resetForm() {
      if (this.$refs["attendanceEmployee"]) {
        setTimeout(() => {
          this.$refs["attendanceEmployee"].resetFields();
        }, 200);
      }
      // Reset file upload
      this.attendanceEmployee.attendanceLeaveEmployee.leavePictureFile = null;
      this.attendanceEmployee = { attendanceLeaveEmployee: {} };
      this.fullNameTitle = "";
    },

    // Xử lý khi image-uploader thay đổi
    handleImageChange(file) {
      this.attendanceEmployee.attendanceLeaveEmployee.leavePictureFile = file;

      // Validate giống logic cũ
      const isValidType = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 <= 5;

      if (!isValidType) {
        this.$message.error("Chỉ chấp nhận file JPG hoặc PNG");
        this.attendanceEmployee.attendanceLeaveEmployee.leavePictureFile = null;
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB");
        this.attendanceEmployee.attendanceLeaveEmployee.leavePictureFile = null;
      }
    },

    submitForm(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (!valid) {
          this.$message.error("Vui lòng kiểm tra thông tin");
          return;
        }

        const inputData = this.attendanceEmployee.attendanceLeaveEmployee;
        const formData = new FormData();

        // Append các field text
        formData.append("leaveContent", inputData.leaveContent || "");
        if (inputData.id) {
          formData.append("id", inputData.id);
        }

        // Append file nếu có thay đổi
        if (inputData.leavePictureFile instanceof File) {
          formData.append("multipartFile", inputData.leavePictureFile);
        }

        this.loadingButton = true;

        AttendanceEmployeeService.updateLeaveContent(inputData.id, formData)
            .then(() => {
              this.$message.success("Lưu chấm công về thành công");
              setTimeout(() => {
                this.closeDialogByButton();
              }, 500);
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("Lưu chấm công về thất bại");
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      });
    },

    getDataLeaveRowInitial(row) {
      this.attendanceEmployee = row;
      this.fullNameTitle = "Thông tin chấm công về: " + (row.attendanceInfoEmployee?.fullName || "");

      // Đảm bảo file upload mới là null ban đầu
      this.attendanceEmployee.attendanceLeaveEmployee.leavePictureFile = null;
    },
  }
};
</script>

<style scoped>
/* Đồng bộ style với các dialog trước */

.shift-card {
  padding: 18px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.shift-header {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1f74d4;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.shift-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.shift-col {
  display: flex;
  flex-direction: column;
}

.shift-media {
  width: 180px;
  align-items: center;
  text-align: center;
}

.shift-note {
  flex: 1;
}

.shift-media-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.shift-time {
  margin-top: 10px;
  color: #4177e2;
  font-size: 16px;
  font-weight: 500;
}

.shift-status {
  margin-top: 20px;
  font-size: 13px;
  line-height: 1.6;
}

.shift-status strong {
  color: #1f74d4;
}

/* Dialog chung */
::v-deep .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
  background: #fafbff;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #4da3ff, #1f74d4);
  padding: 16px 20px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 20px !important;
  font-weight: bold;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
}

::v-deep .el-dialog__footer {
  background: #f5f7fa;
  padding: 14px 20px !important;
  border-top: 1px solid #dcdfe6;
}

::v-deep .el-button--success:hover {
  background: #40c463;
  border-color: #40c463;
}

::v-deep .el-button--danger:hover {
  background: #ff6b6b;
  border-color: #ff6b6b;
}
</style>